export class ApiHttpError extends Error {
    status;
    code;
    details;
    constructor(status, code, message, details) {
        super(message);
        this.status = status;
        this.code = code;
        this.details = details;
        this.name = "ApiHttpError";
    }
}
//# sourceMappingURL=errors.js.map